<div class="text-info"><p><b>{{info.Question}}</b>: {{ info.Response | translate }}</p></div>
